import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow
} from '@mui/material';
import ClipBoardTexte from 'utils/copyClipboard';

const DynamicTable = ( { data } : { data: any[] } ) => {
  // Extract keys for column headers from the first object
  const columns = data.length > 0 ? Object.keys(data[0]).map((key) => {

    const colInfo = data[0][key];
    const titre = colInfo.split(",")[0]; // Use the first part as the title
    const align = colInfo.match(/,align=(left|center|right)/)?.[1] || 'left'; // Extract alignment if specified

    return {
      key: key,
      titre: titre,
      align: align
    };
  }) : [];
  //console.log("DynamicTable data:", data);
  //console.log("DynamicTable columns:", columns);

  return (
    <TableContainer sx={{ maxHeight: 240, scrollbarColor: '#8b8b8b #efefef' }}>
      <Table size="small" 
                          sx={{
                              '& .MuiTableCell-root': {
                                fontFamily: 'Roboto !important',
                                paddingLeft: '4px !important',
                                paddingRight: '4px !important',
                              }
                            }}
                          >
        <TableHead>
          <TableRow>
            {columns.map((col) => { 
              return (
                <TableCell key={"tr-" + col.key} padding={'none'} sx={{ fontSize: '0.75rem', py: 0.5, px: 1  }} align={col.align}>{col.titre}</TableCell>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => { 
            if (index === 0) {
              return (<></>);
            }
            else
            return (
            <TableRow key={index}>
              {columns.map((col) => (
                <TableCell key={"tc-"+index+"-"+col.key} padding={'none'} sx={{ fontSize: '0.75rem', py: 0.5, px: 1 }} align={col.align}>
                  <ClipBoardTexte texte={row[col.key]} ></ClipBoardTexte>
                </TableCell>
              ))}
            </TableRow>
          )})}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DynamicTable;
function createMuiTheme(arg0: {
  overrides: {
    MuiTableCell: {
      root: { //This can be referred from Material UI API documentation. 
        padding: string; backgroundColor: string;
      };
    };
  };
}) {
  throw new Error('Function not implemented.');
}

